module.exports = __webpack_public_path__ + "img/post_box_letter.5d0a1a5d.svg";